"use client";
import { ProgressProvider } from "@bprogress/next/app";

export default function PageProgressProvider({
  children,
}: { children: React.ReactNode }) {
  return (
    <ProgressProvider
      height="3px"
      color="#D9C3FE"
      options={{ showSpinner: false }}
      shallowRouting // ignore `router.push` where only the hash/query changes
    >
      {children}
    </ProgressProvider>
  );
}
